import type { Site } from '../Site';

export const PracticalMotorhome: Site = {
  id: 'practicalmotorhome',
  logo: 'svg/practicalmotorhome.svg',
  label: 'PracticalMotorhome',
  analyticsName: 'practicalmotorhome',
  hostname: 'practicalmotorhome.com',
  platform: 'practical',
  selector: 'article a',
};
